import { MenuDesignTokens } from '@primeuix/themes/types/menu';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const menuOverride: MenuDesignTokens = {
  root: {
    borderRadius: getRem(10),
    background: getColor('UiWhite'),
    color: getColor('SeaBlue'),
    shadow: `0 ${getRem(1)} ${getRem(6)} 0} ${getColor('DarkBlack')}`,
  },
  list: {
    padding: '0',
    gap: '0',
  },
  item: {
    padding: `${getRem(10)} ${getRem(12)}`,
    borderRadius: '0',
    gap: getRem(10),
    focusBackground: getColor('WhiteSmoke'),
    color: getColor('UiBlack'),
    focusColor: getColor('UiBlack'),
    icon: {
      color: getColor('SeaBlue'),
      focusColor: getColor('SeaBlue'),
    },
  },
  separator: {
    borderColor: getColor('SkyBlue80'),
  },
};
